<template>
  <div>
    <md-card v-if="value">
      <ValidationObserver ref="validator">
        <md-card-content class="priceTableContent">
          <md-table id="priceTable" class="priceTable x-sync  ">
            <md-table-row class="thead">
              <md-table-cell class="table-head"></md-table-cell>
              <!-- header travel-date -->
              <md-table-cell
                v-for="label in labels"
                :key="label.label"
                :class="{
                  'table-head': true,
                  'weekend': label.weekend,
                }"
              >
                <small>{{ label.label }}</small>
                <small v-if="label.occ >= 0">{{ label.occ }}%</small>
              </md-table-cell>
            </md-table-row>

            <!-- compset, current, override -->
            <pricing-table-non-hideable-row
              v-for="(dataset, rowNonHideableIndex) in nonHiddeableTableData"
              :key="`nonHiddeableTableData-${rowNonHideableIndex}`"
              :value="dataset"
              @toggleColumn="toggleColumn"
            >
            </pricing-table-non-hideable-row>

            <!-- magic-prices -->
            <md-table-row>
              <md-table-cell class="h6 first-row" :title="value.channels_table.magic_prices_row_dto.label">
                {{ value.channels_table.magic_prices_row_dto.label }}
              </md-table-cell>

              <md-table-cell v-for="(cell, index) in magicPricesRowData" :key="'cell_' + index" md-label="ID">
                <md-checkbox
                  :disabled="!cell.value.price_editable"
                  class="magic-prices"
                  v-model="checkBatch[actualIdx(index)]"
                  :value="actualIdx(index)"
                  @change="toggleColumn(checkBatch[actualIdx(index)], index, false)"
                >
                  <strong>↓</strong>
                </md-checkbox>
              </md-table-cell>
            </md-table-row>

            <!-- hotel allotment -->
            <md-table-row class="table-info" v-if="!!value.channels_table.inventory_row_dto">
              <md-table-cell class="h6 first-row">
                <span>
                  {{ value.channels_table.inventory_row_dto.label }} ({{ value.channels_table.inventory_row_dto.total_physical_rooms }})
                </span>
              </md-table-cell>
              <md-table-cell v-for="(cell, index) in inventaryRowData" :key="'cell2_' + index">
                <allotment-indicator :value="cell.value"></allotment-indicator>
              </md-table-cell>
            </md-table-row>

            <!-- allotment, prices room and board -->
            <pricing-table-row
              v-for="(dataset, hiddeableTableIndex) in hiddeableTableData"
              :key="'ptrow' + hiddeableTableIndex"
              v-show="showHiddeableRows"
              v-model="hiddeableTableData[hiddeableTableIndex]"
              @allotmentSelected="allotmentSelected"
              @pricingSelected="pricingSelected"
            >
            </pricing-table-row>
          </md-table>
        </md-card-content>
      </ValidationObserver>
    </md-card>
    <md-progress-spinner v-else md-mode="indeterminate"></md-progress-spinner>
  </div>
</template>

<script>
/*eslint-disable */

import PricingTableNonHideableRow from '@/components/Pricing/PricingTableNonHideableRow'
import PricingTableRow from '@/components/Pricing/PricingTableRow.vue'
import AllotmentIndicator from '../Allotment/AllotmentIndicator.vue'
import AllotmentRow from '../Allotment/AllotmentRow.vue'

export default {
  components: {
    PricingTableRow,
    PricingTableNonHideableRow,
    AllotmentRow,
    AllotmentIndicator,
  },
  name: 'PricingTableComponent',
  props: {
    value: Object,
    occupancyPerAnticipation: Object,
  },
  data() {
    return {
      checkBatch: [],
      showHiddeableRows: true,
      originalRecomendedData: [],
    }
  },
  computed: {
    nonHiddeableTableData() {
      if (this.value == null) {
        return []
      }
      return this.value.data_table.pricing_price_table_data_set_dto
    },
    magicPricesRowData() {
      if (this.value == null) {
        return []
      }
      return this.value.channels_table.magic_prices_row_dto.magic_data
    },
    inventaryRowData() {
      if (this.value == null) {
        return []
      }
      return this.value.channels_table.inventory_row_dto.inventory_data
    },
    hiddeableTableData() {
      if (this.value == null || this.value.channels_table == undefined) {
        return []
      }
      return this.value.channels_table.pricing_price_channels_data_set_dto
    },
    labels() {
      if (this.value == null) {
        return []
      }
      return this.nonHiddeableTableData.length
        ? this.nonHiddeableTableData[0].data.map((c) => {
            let dayOfWeek = this.moment(c.key).format('E')
            let occ = !!this.occupancyPerAnticipation
              ? Number(
                  this.occupancyPerAnticipation.data_chart_per_anticipation
                    .find((d) => d.key == 0)
                    ?.value.dataset.find((row) => row.key === c.key)
                    ?.value.data.reduce((accumulator, data) => accumulator + data.value, 0)
                ).toFixed(2)
              : -1
            return {
              label: this.moment(c.key).format('DD MMM'),
              weekend: dayOfWeek == 6 || dayOfWeek == 7,
              occ,
            }
          })
        : []
    },
  },
  methods: {
    allotmentSelected: function(isSelected, travelDate, roomTypeId) {
      this.$emit('allotmentSelected', isSelected, travelDate, roomTypeId)
    },
    pricingSelected: function(isSelected, travelDate, roomTypeId) {
      this.$emit('pricingSelected', isSelected, travelDate, roomTypeId)
    },
    actualIdx(idx) {
      return idx
    },
    resetRecommendedValues() {
      this.value.data_table.pricing_price_table_data_set_dto
        .find((t) => t.editable == true)
        .data.forEach((k, index) => {
          k.value.amount = this.originalRecomendedData[index]
        })
    },
    initOriginalRecomended() {
      return new Promise((resolve) => {
        this.originalRecomendedData = [
          ...this.value.data_table.pricing_price_table_data_set_dto.find((t) => t.editable == true).data.map((k) => k.value.amount),
        ]
        resolve()
      })
    },
    toggleColumn(selected, index, override) {
      const actualIdx = this.actualIdx(index)
      selected = selected || selected === 0 ? true : false

      if (override == true) {
        if (!selected) this.checkBatch[actualIdx] = false
        else this.checkBatch[actualIdx] = actualIdx

        this.toggleColumn(selected, index, false)
        this.$forceUpdate()
        return
      }

      Object.keys(this.$refs).forEach((k) => {
        if (override == false && k == 'channel-editable-override') {
          return
        }

        this.value.channels_table.pricing_price_channels_data_set_dto.forEach((element) => {
          const actualColumn = element.data[actualIdx].value.price
          this.$set(actualColumn, 'is_selected', selected)
          this.pricingSelected(selected, element.data[actualIdx].key, element.room_type_id)
        })
      })
    },

    disableCheckboxesTabindex() {
      Array.from(this.$el.getElementsByClassName('checkbox-edited-by-user')).forEach((e) => {
        Array.from(e.getElementsByTagName('input')).forEach((c) => {
          c.setAttribute('tabIndex', '-1')
        })
      })
    },
    loadData(data) {
      this.checkBatch = []
      this.$refs.validator.validate()
      this.disableCheckboxesTabindex()
    },
  },
  watch: {
    value: {
      handler(data) {
        if (!!data && data.length > 0) {
          this.loadData(data)
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/md/_variables.scss';

.magic-prices {
  padding-left: 5px;
}
.amount {
  display: flex;
  justify-content: flex-end;
}
.md-table-cell .md-checkbox {
  zoom: 0.7;
}
.md-table-row .md-table-cell.weekend {
  background-color: #e8e8e8;
}
.md-table-row:hover .md-table-cell.weekend {
  background-color: #e8e8e8 !important;
}
.thead:not(.table-info):hover .md-table-cell:not(.weekend),
.md-table-row:not(.table-info):hover .md-table-cell.first-row:not(.weekend) {
  background-color: #ffffff !important;
}
.md-table-row.table-info:hover .md-table-cell.first-row {
  background-color: #f1f1f1 !important;
}

.priceTableContent .md-table-content {
  max-height: 63em;
  overflow: auto;
  position: relative;
  width: 100%;
}
.priceTable {
  .thead td small {
    display: flex !important;
    justify-content: center;
  }

  td {
    border-right: 1px solid #ddd;
  }

  table {
    position: relative;
    border-collapse: collapse;
    overflow: unset;
    width: 100%;
  }

  tr .table-head {
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    top: -1px;
    z-index: 2;
    background-color: #ffffff;
  }

  tr .first-row {
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    left: 0;
    z-index: 2;
  }

  tr:not(.table-info) .first-row {
    background-color: #ffffff;
  }

  tr.table-info .first-row {
    background-color: #f1f1f1;
  }

  tr .table-head:first-child {
    left: 0;
    z-index: 3;
  }
}

.right {
  float: right;
}

.card-header {
  padding-bottom: 15px;
}

.arrow-button,
.arrow-button:hover,
.arrow-button.md-button .md-ripple {
  background: $brand-primary !important;
}

.arrow-button:hover {
  opacity: 0.95;
}
</style>
